module.exports = __webpack_public_path__ + "static/media/sz.3114bc50.svg";